import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from 'cn';
const alertVariants = cva("group/alert relative grid w-full gap-0.5 rounded-lg border px-2.5 py-2 text-left text-sm has-data-[slot=alert-action]:relative has-data-[slot=alert-action]:pr-18 has-[>svg]:grid-cols-[auto_1fr] has-[>svg]:gap-x-2 *:[svg]:row-span-2 *:[svg]:translate-y-0.5 *:[svg]:text-current *:[svg:not([class*='size-'])]:size-4", {
    variants: {
        variant: {
            default: 'bg-card text-card-foreground',
            /*
             * ПЕРЕКОМПОНОВКА ДЕСТРУКТИВА - РЕШЕНИЕ ВЛАДЕЛЬЦА 2026-09-25.
             *
             * В поставке текст красный на красной подложке 10 %: 3,98:1 в
             * светлой теме и 4,48:1 в тёмной - ниже AA. Новых цветов не
             * заводим: текст берёт `foreground`, красными остаются значок и
             * рамка. Тон читается, контраст проходит, токены прежние.
             */
            destructive: 'border-destructive/40 bg-card text-foreground *:data-[slot=alert-description]:text-foreground *:[svg]:text-destructive',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});
function Alert({ className, variant, ...props }) {
    return (_jsx("div", { "data-slot": "alert", role: "alert", className: cn(alertVariants({ variant }), className), ...props }));
}
function AlertTitle({ className, ...props }) {
    return (_jsx("div", { "data-slot": "alert-title", className: cn('font-medium group-has-[>svg]/alert:col-start-2 [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:text-foreground', className), ...props }));
}
function AlertDescription({ className, ...props }) {
    return (_jsx("div", { "data-slot": "alert-description", className: cn('text-sm text-balance text-muted-foreground md:text-pretty [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:text-foreground [&_p:not(:last-child)]:mb-4', className), ...props }));
}
function AlertAction({ className, ...props }) {
    return (_jsx("div", { "data-slot": "alert-action", className: cn('absolute top-2 right-2', className), ...props }));
}
export { Alert, AlertTitle, AlertDescription, AlertAction };
//# sourceMappingURL=alert.js.map